import { API_ROOT, dispatchGetJSONAsync, completeJSONAsync } from './BaseApi';
import appdata from '../Services/appdata';

const ApiDefault = () => {
  const getDefaultInfo = async () => {
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/default/${company_id}/Info/${company_org_id}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  return {
    getDefaultInfo,
  };
};

export default ApiDefault();
